/**
 * Adzuki.Toast(status, message[, options])
 *
 * A quick confirmation from anywhere on a page, in the shared <adzuki-toast>
 * (MEDIA-333). Pages with their own Vue app can still render <adzuki-toast> and
 * call it by ref, as Maxx Media does; this is for the rest: code outside a Vue
 * app, and the Trip Summary forms that each carried their own copy of a
 * #liveToast routine. The component is mounted once, on first use, and reused.
 *
 * status: 'success' (default), 'error', 'warning' or 'info'
 */
(function Toast($, Adzuki)
{
	'use strict';

	let instance = null;

	function mount()
	{
		if (instance) {
			return instance;
		}

		if (!window.Vue || !Adzuki.VueComponents || !Adzuki.VueComponents.AdzukiToast) {
			return null;
		}

		const el = document.createElement('div');

		el.className = 'adzuki-toast-host';
		document.body.appendChild(el);

		// Bootstrap's toast layer (1090) rather than the component's 1055, so a
		// toast raised from inside a modal shows over it -- Trip Summary's picker
		// shell is 1060, which hid the drawer's "Link copied" (MEDIA-286)
		instance = window.Vue.createApp(Adzuki.VueComponents.AdzukiToast, {
			containerStyle: 'z-index: 1090; margin-top: 20px;'
		}).mount(el);

		return instance;
	}

	Adzuki.Toast = function toast(status, message, options)
	{
		const component = mount();

		if (!component) {
			// no Vue on this page: say it some other way rather than not at all
			return Adzuki.StatusMessage(status === 'error' ? 'error' : 'success', message);
		}

		component.openToast(status || 'success', message, options || {});
	};
}(jQuery, window.Adzuki || {}));
